/**
 * Created by kirandogra on 20/07/18.
 */
App.controller('addDriverController',[ '$scope','API','$location','$http','driverService','$mdToast','$rootScope',function( $scope,API,$location,$http,driverService,$mdToast,$rootScope) {

    history.pushState(null, null, location.href);
    window.onpopstate = function () {
        history.go(1);
    };
    $rootScope.loading_custom = true;
    if(!localStorage.getItem('phone_no'))
        $location.path('/');

    $rootScope.loading_custom = false;
    $scope.imageuploading = false;

    $scope.sideBarItems = {
        'Verify Phone' : 1,'Driver Information': 2, 'Vehicle Information': 3, 'Upload Documents': 4}

    $scope.driver = {};
    var toast;
    $scope.showTab;
    $scope.taskBar;
    $scope.year_check = false;
    $scope.doors_check = false;
    $scope.salvage_check = false;
    $scope.vehicle = {};
    //$scope.current_year = (new Date()).getFullYear();
    $scope.year_list = {};

    for(var i = 2008; i <= (new Date()).getFullYear(); i++) {
        $scope.year_list[i] = i;
    }
    try{
        $scope.driver_documents = JSON.parse(localStorage.getItem('driver_documents'))
    }
    catch(err) {
        $scope.driver_documents = [];
    }

    var driver_info = JSON.parse(localStorage.getItem('driver_info'));
    document.getElementById('progressBar').style.width = $scope.taskBar+'%';

    function getCurrentState(){
        $scope.showTab =  (localStorage.getItem('nextTab')) ? Number(localStorage.getItem('nextTab')) : 1;
        $scope.taskBar = (localStorage.getItem('currentTaskBar')) ? Number(localStorage.getItem('currentTaskBar')) : 0;
        $scope.currentState = (localStorage.getItem('currentTab')) ? Number(localStorage.getItem('currentTab')) : 1;

        if($scope.currentState > 3)
        {
            $scope.year_check = true;
            $scope.doors_check = true;
            $scope.salvage_check = true;
        }
        document.getElementById('progressBar').style.width = $scope.taskBar+'%';
        setTimeout(function(){
            for(var val in $scope.sideBarItems) {
                if($scope.sideBarItems[val] < $scope.currentState)
                {

                    document.getElementById('currentState_'+$scope.sideBarItems[val]).classList.add('completed-task')
                    $("#currentState_"+$scope.sideBarItems[val]).css("pointer-events", "auto");
                }
                else if($scope.sideBarItems[val] > $scope.currentState)
                {
                    $("#currentState_"+$scope.sideBarItems[val]).css("pointer-events", "none");
                }
            }
            $("#currentState_"+$scope.currentState).css("pointer-events", "auto");
            document.getElementById('currentState_'+$scope.sideBarItems['Verify Phone']).style.cursor = 'default';

        },100)
        $('#tab_'+ $scope.showTab).hide();
        $('#tab_'+ $scope.showTab).fadeIn(800);


    }
    getCurrentState()

    function switchTabs(key){

            $scope.showTab = key;

            var citySelected;

            for (var val in $scope.cities) {
                if ($scope.cities[val].city_id == localStorage.getItem('city_id')) {
                    delete $scope.cities[val].$$hashKey;
                    citySelected = JSON.stringify($scope.cities[val])
                }

            }
            var driver = JSON.parse(localStorage.getItem('driver_info'));
            driver.city = citySelected;
            localStorage.setItem('driver_info', JSON.stringify(driver));

            $scope.driver = JSON.parse(localStorage.getItem('driver_info'));
            driver_info = JSON.parse(localStorage.getItem('driver_info'));


            switch (key) {
                case 2:
                    $scope.driver = JSON.parse(localStorage.getItem('driver_info'));
                    break;
                case 3:

                    var vehicle_info = JSON.parse(localStorage.getItem('vehicle_info'));
                    if (vehicle_info) {
                        $scope.vehicle.vehicle_year = (vehicle_info.vehicle_year).toString();
                        $scope.vehicle.vehicle_no = vehicle_info.vehicle_no
                    }
                    getVehicleMakeDetails(vehicle_info);
                    break;
                case 4:
                    fetchDocumentsList()
                    break;
            }

    }

    $scope.changeStateTab = function (key){
        if(key != 1 && key !=  $scope.showTab) {

            switchTabs(key);
            $('#tab_'+key).hide();

            $('#tab_'+key).fadeIn(800)
        //    $scope.showTab = key;
        //
        //    var citySelected;
        //
        //    for (var val in $scope.cities) {
        //        if ($scope.cities[val].city_id == localStorage.getItem('city_id')) {
        //            delete $scope.cities[val].$$hashKey;
        //            citySelected = JSON.stringify($scope.cities[val])
        //        }
        //
        //    }
        //    var driver = JSON.parse(localStorage.getItem('driver_info'));
        //    driver.city = citySelected;
        //    localStorage.setItem('driver_info', JSON.stringify(driver));
        //
        //    $scope.driver = JSON.parse(localStorage.getItem('driver_info'));
        //    driver_info = JSON.parse(localStorage.getItem('driver_info'));
        //
        //
        //    switch (key) {
        //        case 2:
        //            $scope.driver = JSON.parse(localStorage.getItem('driver_info'));
        //            break;
        //        case 3:
        //
        //            var vehicle_info = JSON.parse(localStorage.getItem('vehicle_info'));
        //            if (vehicle_info)
        //                $scope.vehicle.vehicle_year = vehicle_info.vehicle_year;
        //            getVehicleMakeDetails(vehicle_info);
        //            break;
        //        case 4:
        //            fetchDocumentsList()
        //            break;
        //    }
        }

    }

    function fetchVehicleTypes(fetchDetails){

        driverService.getVehicleTypes().then(function(res){
            if(res.data.flag == responseStatus.SUCCESS){
                $scope.cities = res.data.cities;
                $scope.driver.city = JSON.stringify($scope.cities[0]);
                $scope.vehicle_types = $scope.cities[0].vehicle_types;
                $scope.driver.vehicle_type = JSON.stringify($scope.vehicle_types[0].vehicle_type)
                if(fetchDetails)
                    switchTabs($scope.currentState)
            }
            if(res.data.flag == responseStatus.SESSION_EXPIRED)
            {
                createToast('warning','Your login session has expired. Please try again');
                $location.path('/');
            }
        })
    }
    if(localStorage.getItem('access_token'))
        fetchVehicleTypes('getOnlyDetails')


    $scope.moveToAddVehicle = function(){
        var reqObj = {
            user_name: $scope.driver.name + ' ' +  $scope.driver.last_name,
            city: (JSON.parse($scope.driver.city)).city_id,
            vehicle_type: 3,
            updated_user_email: $scope.driver.email_id

        }
        driverService.updateDriverInfo(reqObj).then(function(res){

           if(res.data.flag == responseStatus.SUCCESS){
               localStorage.setItem('driver_info', JSON.stringify($scope.driver))
               localStorage.setItem('city_id',(JSON.parse($scope.driver.city)).city_id);

               var vehicle_info = JSON.parse(localStorage.getItem('vehicle_info'));
               if(vehicle_info) {
                   $scope.vehicle.vehicle_year = (vehicle_info.vehicle_year).toString();
                   getVehicleMakeDetails(vehicle_info);
               }
               else
               getVehicleMakeDetails()
               localStorage.setItem('nextTab',$scope.sideBarItems['Vehicle Information'] )
               if(localStorage.getItem('currentTaskBar') < 50)
                    localStorage.setItem('currentTaskBar',50);
               if( localStorage.getItem('currentTab') < localStorage.getItem('nextTab') )
                   localStorage.setItem('currentTab',$scope.sideBarItems['Vehicle Information']);
               getCurrentState()
               //localStorage.setItem('vehicle_type',$scope.driver.vehicle_type)
           }
           else if(res.data.flag == responseStatus.SESSION_EXPIRED)
           {
               createToast('warning','Your login session has expired. Please try again');
               $location.path('/');
           }
            else {
               createToast('warning',res.data.error);
           }
        })
        //$location.path('/vehicle');
    }

    $scope.getCityId = function (city){
        localStorage.setItem('city_id', city.city_id);
        $scope.vehicle_types = city.vehicle_types;
    }

    function createToast(type,content) {
        if(toast)  $mdToast.hide();
        toast = $mdToast.show($mdToast.simple().position('bottom left').textContent(content));
    }



    $scope.verifyOtp = function() {
        if($scope.otp) {
            var reqObj =
            {
                phone_no: localStorage.getItem('phone_no'),
                login_otp: $scope.otp
            }

            driverService.verifyOtp(reqObj).then(function(res){
                if (res.data.flag == responseStatus.REGISTER_SUCCESS) {
                    localStorage.removeItem('vehicle_info');
                    localStorage.removeItem('driver_info');
                    $scope.otperror = "";
                    localStorage.setItem('access_token', res.data.access_token);
                    fetchVehicleTypes('fetchVehicleTypes');
                        if(res.data.login.user_name == 'Driver' || res.data.login.city == 0){
                            //$scope.currentState = $scope.sideBarItems['Driver Information'];
                            localStorage.setItem('currentTab',$scope.sideBarItems['Driver Information'] );
                            localStorage.setItem('nextTab',$scope.sideBarItems['Driver Information'] );
                            localStorage.setItem('currentTaskBar',25)
                            getCurrentState();

                        }
                        else{

                            var userName = res.data.login.user_name.split(" ");

                            var driverObject = {
                                email_id: res.data.login.user_email,
                                name: userName[0],
                                last_name: userName[1],
                                vehicle_type: 3

                            }

                            localStorage.setItem('driver_info', JSON.stringify(driverObject));
                            localStorage.setItem('city_id',res.data.login.city );

                            if(typeof res.data.login.make_details == "undefined"){
                                //$scope.currentState = $scope.sideBarItems['Vehicle Information'];
                                localStorage.setItem('currentTab',$scope.sideBarItems['Vehicle Information']);
                                localStorage.setItem('nextTab',$scope.sideBarItems['Vehicle Information'] )
                                localStorage.setItem('currentTaskBar',50)
                                getCurrentState();
                                var vehicle_make = null;
                                getVehicleMakeDetails(vehicle_make,res.data.login.city);
                            }

                            else
                            {
                                //$scope.currentState = $scope.sideBarItems['Upload Documents'];
                                localStorage.setItem('currentTab',$scope.sideBarItems['Upload Documents']);
                                localStorage.setItem('nextTab',$scope.sideBarItems['Upload Documents']);
                                localStorage.setItem('currentTaskBar',75)
                                document.getElementById('progressBar').style.width = $scope.taskBar+'%';
                                var vehicleObject = res.data.login.make_details;
                                vehicleObject.vehicle_year = res.data.login.vehicle_year;
                                vehicleObject.vehicle_no = res.data.login.vehicle_no;
                                $scope.vehicle.vehicle_year = (res.data.login.vehicle_year).toString();
                                $scope.vehicle.vehicle_no = res.data.login.vehicle_no;
                                localStorage.setItem('vehicle_info', JSON.stringify(vehicleObject));
                                getCurrentState(vehicleObject);
                                fetchDocumentsList();

                                //getVehicleMakeDetails(vehicleObject);

                            }
                        }

                }
                else if(res.data.flag == responseStatus.LOGIN_SUCCESS)
                {
                    $scope.otperror = 'You are already registered with us. Please login into Driver app';
                }
                else {
                    $scope.otperror = res.data.error;
                }
            })
        }
        else{
            $scope.otperror="Please enter 4-digit OTP"
        }
    }


    //for vehicle details
    function compareCarModel(a,b) {
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    }

    function sortValue(a,b) {
        if (a.value < b.value)
            return -1;
        if (a.value > b.value)
            return 1;
        return 0;
    }
    $scope.objectKeys = function(obj){
        if(!obj)
            return [];
        return Object.keys(obj);
    }

    function getVehicleMakeDetails(vehicleMake,city){
        driver_info = JSON.parse(localStorage.getItem('driver_info'))
        var reqObj = {
            city_id: (city) ? city : JSON.parse(driver_info.city).city_id,
            vehicle_type: 3
        }
        driverService.getVehicleMakeDetails(reqObj).then(function(res){
            if(res.data.flag == responseStatus.SUCCESS) {
                $scope.car_company = res.data.data;
                $scope.car_company = Object.keys(res.data.data).map(function(key) {
                    return {brand:key, value: res.data.data[key]};
                });
                if (vehicleMake) {

                    for(var car in  $scope.car_company ) {
                       if(vehicleMake.brand == $scope.car_company[car].brand)
                           $scope.vehicle.vehicle_name = JSON.stringify($scope.car_company[car].value)
                    }

                    $scope.getModel($scope.vehicle.vehicle_name, vehicleMake)
                    //for(var v in $scope.car_model )
                    //{
                    //    if(carModel[v].model_id == vehicleMake.model_id)
                    //    {
                    //        $scope.vehicle.vehicle_model = carModel[v];
                    //
                    //    }
                    //}
                }
            }
            else if(res.data.flag == responseStatus.SESSION_EXPIRED)
            {
                createToast('warning','Your login session has expired. Please try again');
                $location.path('/');
            }

        })
    }


    $scope.getModel = function(vehicle, selected_model)
    {
        try{
            $scope.car_model = JSON.parse(vehicle);
            $scope.car_model.sort(compareCarModel);
        }
        catch(err){
            $scope.car_model = {};
        }
        $scope.car_customization = {};
        $scope.vehicle.vehicle_model = '';
        $scope.vehicle_colors = {};
        $scope.vehicle.color_name = '';
        $scope.vehicle.no_of_doors = '';
        $scope.vehicle.no_of_seat_belts = '';
        if(selected_model)
        {
            for( var v in $scope.car_model )
            {
                if(selected_model.model_id == $scope.car_model[v].model_id) {
                    $scope.vehicle.vehicle_model = JSON.stringify($scope.car_model[v]);
                    $scope.getCustomizations($scope.vehicle.vehicle_model,selected_model)
                }
            }
        }

    }

    $scope.getCustomizations = function(model,selected_color){
        try{
            $scope.car_customization =  JSON.parse(model);
            getColorCustomizations(selected_color);
            //$scope.vehicle.no_of_doors =  $scope.car_customization.no_of_doors;
            //$scope.vehicle.no_of_seat_belts = $scope.car_customization.no_of_seat_belts;

        }
        catch(err){
            $scope.car_customization = {};
            //$scope.vehicle.no_of_doors = '';
            //$scope.vehicle.no_of_seat_belts = '';

        }
        $scope.vehicle_colors = {};
        $scope.vehicle.color_name = '';
        $scope.vehicle_doors = {};
        $scope.vehicle.no_of_doors = '';
        $scope.vehicle_seat_belts = {};
        $scope.vehicle.no_of_seat_belts = '';

    }

    function getColorCustomizations(selected_color){
        var Obj = {
            city_id: JSON.parse(driver_info.city).city_id,
            vehicle_type: driver_info.vehicle_type,
            model_id: $scope.car_customization.model_id
        }
        driverService.getVehicleColor(Obj).then(function(res) {
            if (res.data.flag == responseStatus.SUCCESS){
                $scope.vehicle_colors = res.data.data.colors;
                $scope.vehicle_doors = res.data.data.doors;
                $scope.vehicle_seat_belts = res.data.data.seat_belts;
                $scope.vehicle_colors.sort(sortValue);
                $scope.vehicle_doors.sort(sortValue);
                $scope.vehicle_seat_belts.sort(sortValue);
            if (selected_color) {
                for (var val in $scope.vehicle_colors) {
                    if (selected_color.color_id == $scope.vehicle_colors[val].id) {

                        $scope.vehicle.color_name = ($scope.vehicle_colors[val].id).toString()
                        //$scope.getVehicleId($scope.vehicle.color_name)
                    }
                }
                for (var val in $scope.vehicle_doors) {
                    if (selected_color.door_id == $scope.vehicle_doors[val].id) {
                        $scope.vehicle.no_of_doors = ($scope.vehicle_doors[val].id).toString()
                    }
                }
                for (var val in $scope.vehicle_seat_belts) {
                    if(selected_color.seat_belt_id == $scope.vehicle_seat_belts[val].id) {
                        $scope.vehicle.no_of_seat_belts = ($scope.vehicle_seat_belts[val].id).toString();
                    }
                }
            }
        }
            else if(res.data.flag == responseStatus.SESSION_EXPIRED)
            {
                createToast('warning','Your login session has expired. Please try again');
                $location.path('/');
            }
            else
                createToast('warning','Something went wrong');
        })
    }

    //$scope.getVehicleId = function(color_object){
    //    try{
    //        $scope.selected_vehicle = JSON.parse(color_object);
    //    }
    //    catch(err){
    //        $scope.selected_vehicle = {};
    //
    //    }
    //}

    $scope.registerVehicle = function(){
        var vehicle_details = {
            door_id : $scope.vehicle.no_of_doors,
            seat_belt_id : $scope.vehicle.no_of_seat_belts,
            color_id : $scope.vehicle.color_name,
            model_id : $scope.car_customization.model_id
        }

        var reqObj = {
            vehicle_details: JSON.stringify(vehicle_details),
            vehicle_year: $scope.vehicle.vehicle_year,
            vehicle_type: driver_info.vehicle_type,
            city: JSON.parse(driver_info.city).city_id,
            user_name:  driver_info.name +' '+ driver_info.last_name,
            vehicle_no: $scope.vehicle.vehicle_no
        }

        driverService.updateDriverInfo(reqObj).then(function(res){
            if(res.data.flag == responseStatus.SUCCESS)
            {
                var vehicleObj = {
                    brand: JSON.parse($scope.vehicle.vehicle_model).brand,
                    color: JSON.parse($scope.vehicle.color_name).color,
                    id: JSON.parse($scope.vehicle.color_name).id,
                    model_id: JSON.parse($scope.vehicle.vehicle_model).model_id,
                    model_name: JSON.parse($scope.vehicle.vehicle_model).name,
                    no_of_doors: $scope.vehicle.no_of_doors,
                    no_of_seat_belts: $scope.vehicle.no_of_seat_belts,
                    vehicle_type: driver_info.vehicle_type,
                    vehicle_year: $scope.vehicle.vehicle_year,
                    vehicle_no: $scope.vehicle.vehicle_no,
                    door_id : $scope.vehicle.no_of_doors,
                    seat_belt_id : $scope.vehicle.no_of_seat_belts,
                    color_id : $scope.vehicle.color_name,

                }

                localStorage.setItem('vehicle_info',JSON.stringify(vehicleObj))
                localStorage.setItem('nextTab',$scope.sideBarItems['Upload Documents'] )
                if( localStorage.getItem('currentTaskBar') < 75)
                localStorage.setItem('currentTaskBar',75)
                if( localStorage.getItem('currentTab') < localStorage.getItem('nextTab') )
                    localStorage.setItem('currentTab',$scope.sideBarItems['Upload Documents'] )
                //$scope.showTab = $scope.sideBarItems['Upload Documents'];
                //$scope.taskBar = 75;
                //document.getElementById('progressBar').style.width = $scope.taskBar+'%';
                //for(var val in $scope.sideBarItems) {
                //    if($scope.sideBarItems[val] < $scope.showTab)
                //    {
                //        console.log(document.getElementById('currentState_'+$scope.sideBarItems[val]))
                //        document.getElementById('currentState_'+$scope.sideBarItems[val]).classList.add('completed-task')
                //    }
                //}
                fetchDocumentsList()
                getCurrentState();
            }

            else if(res.data.flag == responseStatus.SESSION_EXPIRED)
            {
                createToast('warning','Your login session has expired. Please try again');
                $location.path('/');
            }
            else {
                createToast('warning',res.data.error);
            }

        })
        //driverService.registerVehicle(reqObj).then(function(res){
        //    console.log(res);
        //})
    }







    function fetchDocumentsList(){

        driverService.fetchDriverDocuments().then(function(res){
            if(res.data.flag == responseStatus.SUCCESS) {
                //$scope.driver_documents = res.data.data;
                localStorage.setItem('driver_documents', JSON.stringify(res.data.data));
                $scope.driver_documents = JSON.parse(localStorage.getItem('driver_documents'));
                if($scope.selectedDoc){
                    for(var document in $scope.driver_documents){
                        if($scope.selectedDoc.doc_type_num == $scope.driver_documents[document].doc_type_num){
                            $scope.selectedDoc = $scope.driver_documents[document];

                        }
                    }
                    $('#metaData').hide();
                    $('#metaData').fadeIn(1000);
                }
            }
            else if(res.data.flag == responseStatus.SESSION_EXPIRED)
            {
                createToast('warning','Your login session has expired. Please try again');
                $location.path('/');
            }
        })
    }


    $scope.getDocumentId = function(docs){
    }

    $scope.getDocID = function(doc){
        $scope.selected_doc = doc
    }

    function uploadImage(file){
        var img_position = -1;
        for (var val in $scope.selected_doc.doc_url) {
            if (!$scope.selected_doc.doc_url[val]) {
                img_position = val;
                break;
            }
        }
        img_position = (img_position == -1) ? 0 : img_position;
        $scope.errorFlag = false;
        var formData = new FormData();
        formData.append("image", file);
        formData.append("doc_type_num", $scope.selected_doc.doc_type_num);
        formData.append("img_position", img_position);

        driverService.uploadDocuments(formData).then(function (res) {
            $scope.imageUploading = false;
            if (res.data.flag == responseStatus.SUCCESS) {
                fetchDocumentsList();
            }
            else if (res.data.flag == responseStatus.SESSION_EXPIRED) {
                createToast('warning', 'Your login session has expired. Please try again');
                $location.path('/');
            }
            else {
                createToast('warning', 'Something went wrong');
            }

        })
    }

    $scope.imageToUpload = function (File) {
        if(File[0]) {
            $scope.imageUploading = true;
            $scope.image_uploaded = File[0];

            if ($scope.image_uploaded.name.indexOf('.png') == -1 && $scope.image_uploaded.name.indexOf('.jpeg') == -1 && $scope.image_uploaded.name.indexOf('.jpg') == -1 && $scope.image_uploaded.name.indexOf('.PNG') == -1 && $scope.image_uploaded.name.indexOf('.JPG') == -1 && $scope.image_uploaded.name.indexOf('.JPEG') == -1) {
                $scope.errorFlag = true;
                createToast('warning', 'File Type Should be .png or .jpeg only');
                //$scope.$apply();
                return;
            }
            if ($scope.image_uploaded.size) {
                var fileSize = $scope.image_uploaded.size / 1024; // in bytes
                if (fileSize > 2048) {
                    var reader = new FileReader();
                    // Set the image once loaded into file reader
                    reader.onload = function (e) {
                        var img = document.createElement("img");
                        img.src = e.target.result;
                        img.addEventListener('load', function () {
                            var canvas = document.createElement("canvas");
                            var canvasDraw = canvas.getContext("2d");
                            canvasDraw.drawImage(img, 0, 0);

                            var MAX_WIDTH = 800;
                            var MAX_HEIGHT = 700;
                            var width = img.width;
                            var height = img.height;

                            if (width > height) {
                                if (width > MAX_WIDTH) {
                                    height *= MAX_WIDTH / width;
                                    width = MAX_WIDTH;
                                }
                            }
                            else {
                                if (height > MAX_HEIGHT) {
                                    width *= MAX_HEIGHT / height;
                                    height = MAX_HEIGHT;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            var canvasDraw = canvas.getContext("2d");
                            canvasDraw.drawImage(img, 0, 0, width, height);

                            var imageURl = canvas.toDataURL("image/png");

                            var blobBin = atob(imageURl.split(',')[1]);
                            var array = [];
                            for (var i = 0; i < blobBin.length; i++) {
                                array.push(blobBin.charCodeAt(i));
                            }
                            var file = new Blob([new Uint8Array(array)], {type: 'image/png'});

                            uploadImage(file)
                        })

                    }
                    // Load files into file reader
                    reader.readAsDataURL($scope.image_uploaded);
                }
                else {
                    uploadImage($scope.image_uploaded)
                }
            }
        }
    };


    $scope.removeDocument = function(key,doc){
        var reqObj = {
            img_position: key,
            doc_type_num: doc.doc_type_num

        }
        driverService.deleteDocument(reqObj).then(function(res){
            fetchDocumentsList();
        })

    }

    $scope.completeRegisteration = function(){
        var reqObj = {
            login_documents: 3
        }
        driverService.completeRegisteration(reqObj).then(function(res){
            if(res.data.flag == responseStatus.SUCCESS){
                $scope.taskBar = 100;
                document.getElementById('progressBar').style.width = $scope.taskBar+'%';
                $('#thankyouModal').modal('show');
            }
            else if(res.data.flag == responseStatus.SESSION_EXPIRED)
            {
                createToast('warning','Your login session has expired. Please try again');
                $location.path('/');
            }
            else {
                createToast('warning',res.data.message);
            }
        })
    }

    $scope.backToHomepage = function (){
        $('#thankyouModal').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $location.path('/')
    }


    $scope.resendOtp = function(){

            var reqObj = {
                phone_no:   localStorage.getItem('phone_no'),
                country_code: localStorage.getItem('country_code'),
                os_version: '',
                device_name: '',
                device_token: ''

            }
            $scope.err_msg = false;
            driverService.generateOtp(reqObj).then(function(res){
                if(res.data.flag == responseStatus.SUCCESS){
                    $scope.erro_msg_show = false;
                }
                else if(res.data.flag == responseStatus.SESSION_EXPIRED)
                {
                    createToast('warning','Your login session has expired. Please try again');
                    $location.path('/');
                }
                else{
                    $scope.err_msg_show = true;
                    $scope.error_message = res.data.message;
                }

            })
            $scope.otp = '';
            $scope.otperror = '';

            //  $location.path('/driver');
        }
    document.getElementById('logoShap').style.pointerEvents = 'auto';

    $scope.openImageModal = function(docs){
        $scope.selectedDoc = docs;
        $('#uploadImage').modal('show');
        $('#metaData').hide();
        $('#metaData').fadeIn(1000);

    }

    $scope.uploadDocMetaData = function (docInfo){
        var doc_values = [];
        for(var info in docInfo){
            doc_values.push({key: docInfo[info].key, value: docInfo[info].value});
        }
        var reqObj = {
            doc_values: JSON.stringify(doc_values),
            doc_type_num: $scope.selectedDoc.doc_type_num
        }
        driverService.uploadDocumentsMetaData(reqObj).then(function (res) {
            if(res.data.flag == responseStatus.SUCCESS){
                $('#uploadImage').modal('hide');
            }
            else {
                createToast('warning',res.data.error);
            }
        })

    }

}])